// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3pBRy","options":"AnswerScale_options__1280V","selected":"AnswerScale_selected__3MwAs"};